import UAParser, { IResult } from 'ua-parser-js'

export default class UserAgent {
  parser: UAParser
  result: IResult
  ua: string

  constructor (uaString?) {
    this.parser = new UAParser(uaString)
    this.result = this.parser.getResult()
    this.ua = this.result.ua
  }

  getUaString () {
    return this.ua
  }

  isMobile () {
    return (this.getDeviceType() === 'mobile' || this.getDeviceType() === 'tablet')
  }

  // in-app browser or channel web
  isLINE () {
    return this.ua.includes('Line')
  }

  isAndroid () {
    return this.getOSName().toLowerCase() === 'android'
  }

  isIOS () {
    return this.getOSName().toLowerCase() === 'ios'
  }

  isPC () {
    switch (this.getDeviceType()) {
      case 'console':
      case 'mobile':
      case 'tablet':
      case 'smarttv':
      case 'wearable':
      case 'embedded':
        return false
    }

    // The ua-parser-js returns undefined device type for a generic Android device so do another check.
    // https://github.com/faisalman/ua-parser-js/blob/a88934fadf2393f3757f1e8b9966d8c0244120b1/src/ua-parser.js#L664
    if (this.isAndroid()) {
      return false
    }

    // The ua-parser-js returns undefined device type for an Apple TV so do another check.
    // https://github.com/faisalman/ua-parser-js/blob/a88934fadf2393f3757f1e8b9966d8c0244120b1/src/ua-parser.js#L421
    //
    // The ua-parser-js returns undefined device type for an Chromecast device so do another check.
    // https://github.com/faisalman/ua-parser-js/blob/a88934fadf2393f3757f1e8b9966d8c0244120b1/src/ua-parser.js#L561
    const { model } = this.parser.getDevice()
    switch (model) {
      case 'Apple TV':
      case 'Chromecast':
        return false
    }

    return true
  }

  getBrowserName () {
    if (this.isLINE() && this.isAndroid()) {
      return 'LINE In-App Browser (Android)'
    } else if (this.isLINE() && this.isIOS()) {
      return 'LINE In-App Browser (iOS)'
    } else {
      return this.result.browser.name
    }
  }

  // console, mobile, tablet, smarttv, wearable, embedded
  getDeviceType () {
    return this.result.device.type || ''
  }

  // Android, iOS, e.t.c.
  getOSName () {
    return this.result.os.name || ''
  }

  // lower than 11.2 ( < 11.2)
  // https://webkit.org/blog/7929/designing-websites-for-iphone-x/
  isLowerThanIOS11dot2 () {
    return this.isIOS() && (parseFloat(this.result.os.version) < 11.2)
  }
}
